import { createContext, useContext, useState } from 'react'

const SidebarCollapseContext = createContext({ forceCollapsed: false, setForceCollapsed: () => {} })

export function SidebarCollapseProvider({ children }) {
  const [forceCollapsed, setForceCollapsed] = useState(false)
  return (
    <SidebarCollapseContext.Provider value={{ forceCollapsed, setForceCollapsed }}>
      {children}
    </SidebarCollapseContext.Provider>
  )
}

export function useSidebarCollapse() {
  return useContext(SidebarCollapseContext)
}
